/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface JiraIssueTypeInfo
 */
export interface JiraIssueTypeInfo {
    /**
     * 
     * @type {string}
     * @memberof JiraIssueTypeInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof JiraIssueTypeInfo
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof JiraIssueTypeInfo
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof JiraIssueTypeInfo
     */
    iconUrl?: string;
}

export function JiraIssueTypeInfoFromJSON(json: any): JiraIssueTypeInfo {
    return {
        'id': json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'iconUrl': !exists(json, 'iconUrl') ? undefined : json['iconUrl'],
    };
}

export function JiraIssueTypeInfoToJSON(value?: JiraIssueTypeInfo): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'iconUrl': value.iconUrl,
    };
}


